import React, { useContext } from 'react';
import styled from 'styled-components';
import { Colors } from '../../../common/colors/colors';
import { useNavigate } from 'react-router';
import Icon from '@/common/components/Icon';
import { endSession } from '../../../API/repositories/user';
import { LOGIN_PATH } from '../../../API/constants/auth';
import { AuthContext } from '@/common/contexts/authContext';

const Wrapper = styled.div`
	width: 30px;
	height: 30px;
	color: ${Colors.red};
	display: flex;
	justify-content: center;
	align-items: center;
	cursor: pointer;
`;

const Loguout = () => {
	const navigate = useNavigate();
	const { setAuthUser } = useContext(AuthContext);

	const handleLogout = async () => {
		await endSession();
		setAuthUser(null);
		navigate(LOGIN_PATH);
	};

	return (
		<Wrapper className='animation-scale' onClick={() => handleLogout()}>
			<Icon name='right-from-bracket' style={{ fontSize: '16px' }} />
		</Wrapper>
	);
};

export default Loguout;
